export default "__VITE_ASSET__BwQRHazh__"